const AbiStatementViewApiUrls = {
  //GET_DAILY: '/na-mig/DEMO_statement-view-table.json',
  GET_ENTRY_SUMMARY: '/na-mig/DEMO_statement-view-dialog-finalized.json',
  //GET_DAILY_PRELIMINARY: '/na-mig/DEMO_statement-view-dialog-preliminary.json',
  //GET_DAILY_FINALIZED: '/na-mig/DEMO_statement-view-dialog-finalized.json',
  GET_DAILY: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/statement/daily/view/get`,
  GET_DAILY_DETAILS: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/statement/daily/view/details/get`,
  GET_ENTRY_SUMMARY_DETAILS: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/statement/daily/entry/details/get`,
  SUBMIT_AUTHZ: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/statement/daily/auth/submit`,
  GET_DAILY_STATEMENT: '', // INTEGRATION: to be defined, and the `...PRELIMINARY` and `...FINALIZED` can be removed. Following that, the fetch logic in StatementDialogContext can be simplified.
  CREATE_STATEMENT_UPDATES: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/statement-update/create`,
  GET_STATEMENT_UPDATES: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/statement-update/list/get`,
  POST_AUTHORIZATION: '',
  GET_MONTHLY: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/statement/monthly/view/get`,
  GET_MONTHLY_PRELIMINARY: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/statement/monthly/view/details/get`,
  GET_MONTHLY_FINALIZED: '/na-mig/DEMO_statement-view-monthly-dialog-finalized.json',
  GET_PMS_DAILY_DETAILS: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/statement/monthly/view/details/daily/get`,
  GET_MONTHLY_STATEMENT: '', // INTEGRATION: to be defined, and the `...PRELIMINARY` and `...FINALIZED` can be removed. Following that, the fetch logic in StatementDialogContext can be simplified.
};

export default AbiStatementViewApiUrls
